import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Message } from "./ui/Message";
import { MessageSquare } from "lucide-react";

export const ChatMessages = ({
  messages,
  isLoading,
  showMetadata = false,
  widgetConfig = null,
}) => {
  const { t } = useTranslation();
  const messagesEndRef = useRef(null);
  const lastMessageRef = useRef(null);
  const previousMessagesLength = useRef(messages.length);

  useEffect(() => {
    const hasNewMessage = messages.length > previousMessagesLength.current;
    const lastMessage = messages[messages.length - 1];

    if (hasNewMessage && lastMessage) {
      if (lastMessage.role === "user") {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
      } else if (lastMessage.role === "assistant" && lastMessage.isStreaming) {
        setTimeout(() => {
          lastMessageRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }, 100);
      }
    }

    previousMessagesLength.current = messages.length;
  }, [messages]);

  const companyName = widgetConfig?.company_name || "TIA GPC";
  const companyLogo = widgetConfig?.company_logo_base64;

  const logoSrc = companyLogo?.startsWith("data:")
    ? companyLogo
    : companyLogo
    ? `data:image/png;base64,${companyLogo}`
    : null;

  if (messages.length === 0 && !isLoading) {
    return (
      <div className="gpc-messages-container">
        <div className="gpc-empty-state">
          {logoSrc ? (
            <div className="gpc-welcome-logo">
              <img
                src={logoSrc}
                alt={companyName}
                className="gpc-welcome-company-logo"
              />
            </div>
          ) : (
            <MessageSquare className="gpc-empty-icon" />
          )}
          <h3 className="gpc-empty-title">
            {t("chat.welcome", { companyName })}
          </h3>
          <p className="gpc-empty-text">{t("chat.emptyState")}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="gpc-messages-container gpc-scrollbar gpc-smooth-scroll">
      {messages.map((message, index) => (
        <Message
          key={message.id}
          message={message}
          showMetadata={showMetadata}
          messageRef={index === messages.length - 1 ? lastMessageRef : null}
        />
      ))}

      <div ref={messagesEndRef} />
    </div>
  );
};